var map = {
	"./1inch.svg": 37854,
	"./arbitrum-disable.svg": 6837,
	"./arbitrum.svg": 7700,
	"./authereum.svg": 12657,
	"./binance.svg": 25119,
	"./bitsky.svg": 87195,
	"./coin98.svg": 1052,
	"./coinbase.svg": 36177,
	"./fewcha.jpeg": 19572,
	"./fortmatic.svg": 1939,
	"./funfairwallet.svg": 53214,
	"./keepkey.svg": 47562,
	"./ledger.svg": 89118,
	"./martian.jpeg": 33071,
	"./metamask.svg": 11907,
	"./mew.svg": 94059,
	"./petra.jpeg": 49126,
	"./phantom.svg": 5354,
	"./pontem.jpeg": 76354,
	"./portis.svg": 17490,
	"./torus.svg": 12573,
	"./trezor.svg": 45218,
	"./venly.svg": 992,
	"./walletconnect.svg": 27555,
	"./walletlink.svg": 49069,
	"./web3.svg": 15170
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 37245;